<section class="service-page">
  <div class="row pad">
    <div class="service-page__inner">
      <div class="text-muted">16th April 2026</div>
      <h1>Privacy Notice</h1>

      <p>
        <strong
          >AE EventsCo, LLC and Affiliates Engagement Privacy Notice</strong
        >
      </p>

      <ol>
        <li>
          <strong>Data Controllers and Contact Details:</strong>
          Your personal information is collected and processed by AE EventsCo,
          LLC and its subsidiaries and affiliated entities (together, the "AE
          Group") in connection with your application for employment,
          engagement, or consultancy services, as well as any subsequent
          engagement. Depending on the nature of your application or engagement
          and the AE Group entity involved, the relevant AE Group company will
          act as the data controller of your personal information. AE EventsCo,
          LLC may also act as a joint controller with certain affiliates where
          groupwide or centralized systems, platforms, or services are used. If
          you would like to know which AE Group entity is responsible for your
          personal information in connection with your application or
          engagement, please contact us using the details below. For all
          questions, concerns, or to exercise your data protection rights, you
          may contact the AE Group at:
          <a href="mailto:contactus@marigrp.com">contactus@marigrp.com</a>.
        </li>
        <li>
          <strong>Personal Information Collected:</strong>
          We collect the information below about you during the recruitment and
          selection process, and, if applicable, during your engagement with us.
          If you fail to provide certain information when requested we will not
          be able to perform all our obligations regarding your engagement.
          <ul>
            <li>
              <strong
                >Personal identifiers and professional information
                including:</strong
              >
              Title, name, date of birth, age, gender, home address, personal
              email address, social security number, information on your
              education and professional expertise.
            </li>
            <li>
              <strong
                >Recruitment and application information including:</strong
              >
              CVs and resumes, cover letters, application forms, employment and
              education history, professional qualifications, work authorization
              status, references, interview notes and assessments, results of
              aptitude or skills testing, and publicly available professional
              profile information (such as LinkedIn), where relevant to your
              application.
            </li>
            <li>
              <strong
                >Recruitment and engagement records including (where
                applicable):</strong
              >
              Offer letters, recommendations, policy acknowledgements,
              consultancy/contractor or other agreements, engagement agreements,
              termination letters, absence records, and training records.
            </li>
            <li>
              <strong>Contractor/Consultant details including:</strong>
              Job title, description of services/ duties, contractor/consultant
              ID, work location, start date, termination data, individual photo,
              travel expenses, bank account information and invoices, company
              registration number and VAT registration number.
            </li>
            <li>
              <strong>Information about criminal convictions:</strong>
              We may carry out background checks as part of the recruitment or
              engagement process where appropriate given the nature of the role
              or services and where we are legally able to do so.
            </li>
            <li>
              <strong>Compliance information including:</strong>
              Records generated in relation to investigations, CCTV footage and
              your use of our IT systems if any.
            </li>
            <li>
              <strong>Emergency contact information:</strong>
              The name and contact details of your next of kin.
            </li>
            <li>
              <strong>Special categories of personal data including:</strong>
              Information relating to disabilities, physical or mental health
              information and immigration/naturalisation records (if this
              discloses racial/ ethnic origin information).
            </li>
          </ul>
        </li>
        <li>
          <strong>Sources of Information:</strong>
          This information is either (a) provided by you; (b) obtained from
          third parties through the engagement process; or (c) created by us in
          the course of your engagement. In particular, data may be obtained
          from the following third parties: recruitment agencies, headhunters,
          talent platforms, referees, background check providers, talent
          agencies, production companies, credit reference agencies, or other
          background check agencies.
        </li>
        <li>
          <strong>How and Why We Use Your Information:</strong>
          We process your personal information to evaluate and manage your
          application, administer and manage recruitment and selection
          processes, determine your suitability for a role or engagement,
          communicate with you about opportunities, and, if applicable,
          administer and manage your engagement, comply with legal and
          regulatory obligations, protect our systems and assets, prevent fraud
          or misuse, respond to emergencies, and manage disputes or legal
          claims. We rely on the following legal bases: steps taken at your
          request prior to entering into a contract, performance of your
          engagement agreement, compliance with law, protection of vital
          interests, and our legitimate interests in effective business
          administration, recruitment, IT and network security, fraud
          prevention, and business continuity. We process special category and
          criminal record data only where required by law, necessary for legal
          claims, to protect vital interests, because you made the information
          public, or with your explicit consent and only where lawful and
          relevant to your engagement.
        </li>
        <li>
          <strong>Information that We Share:</strong>
          We may share your personal information within the AE Group, with
          service providers supporting our operations, clients where necessary
          for your engagement, regulators or authorities where required by law,
          and potential purchasers or parties involved in restructuring. We may
          also disclose information to prevent fraud or protect our rights,
          systems, and assets.
        </li>
        <li>
          <strong>Retention of Your Information:</strong>
          We will only retain your personal information for as long as necessary
          to fulfil the purposes we collected it for, including for the purposes
          of satisfying any legal, accounting or reporting requirements. In
          general terms, this means: (A) If you are not engaged, we will retain
          your application and recruitment information for a limited period
          following the conclusion of the recruitment process, as required by
          applicable law or for the establishment or defense of legal claims;
          (B) If you are engaged, we will retain your personal information for
          the duration of your engagement with us and for the length of any
          applicable limitation period for claims which might be brought against
          us later (e.g. 6 years in the UK).
        </li>
        <li>
          <strong>Where Your Information Will Be Held:</strong>
          Your information may be transferred within the AE Group, including
          outside the UK/EU. Where this occurs, we apply appropriate safeguards
          which are available on request.
        </li>
        <li>
          <strong>Security:</strong>
          We follow strict security procedures as to how your personal
          information is stored and used, and who sees it, to help stop any
          unauthorised person accessing it.
        </li>
        <li>
          <strong>Your Rights:</strong>
          This notice applies to individuals who apply for roles with the AE
          Group, whether or not an engagement is entered into, as well as
          contractors and consultants who provide services to the AE Group. You
          have the following rights in connection to your data: the rights of
          access, correction, erasure, objection, restriction, transfer, and the
          right to withdraw consent and to complain to a Supervisory Authority.
          If you want to exercise any of these rights, please contact us in
          writing at
          <a href="mailto:contactus@marigrp.com">contactus@marigrp.com</a>.
        </li>
        <li>
          <strong>Changes to This Notice:</strong>
          This notice will be changed from time to time. If we change anything
          important about this notice (the information we collect, how we use it
          or why) we will notify you. If you would like to access previous
          versions of this notice please contact
          <a href="mailto:contactus@marigrp.com">contactus@marigrp.com</a>.
        </li>
      </ol>
    </div>
  </div>
</section>
